import React, { useState, useRef, useEffect } from 'react'
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import Card from '../../Base/Components/Card/Card';
import { FacturacionDiaria } from '../../API/Ventas/ResumenVentasRequest';
import { Toast } from 'primereact/toast';
import { toastShow } from '../../Base/Services/ToastService';
import { getDateProduction } from '../../Base/Services/FechasService';
import Loader from '../../Base/Components/Loader/Loader';
import AgGrid from '../../Base/Components/Tables/AgGrid/AgGrid';
import { setTitlePage } from '../../Base/Services/Config/ConfigService';

const FacturacionDiariaScreen = () => {

  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [fechas, setFechas] = useState([new Date(), new Date(new Date().getTime() + 1000 * 60 * 60 * 24 )]);
  const [table, setTable] = useState({
    Data: [],
    Columns: [
      {
        // Fecha
        field: 'FechaFactura',
        header: 'Fecha',
        className: 'colum-width-small',
        body: (rowData) => rowData.FechaFactura,
        align: 'center',
        frozen: "frozen",
        alignFrozen: "left",
      },
      {
        // Factura
        field: 'NumeroFactura',
        header: 'Factura',
        className: 'colum-width-XXlarge',
        body: (rowData) => rowData.NumeroFactura,
        align: 'center',
        Sumary: 'count',
        frozen: "frozen",
        alignFrozen: "left",
      },
      {
        // Cliente
        field: 'CustomerName',
        header: 'Cliente',
        body: (rowData) => rowData.CustomerName,
        frozen: "frozen",
        alignFrozen: "left",
      },
      {
        // StyleCategory
        field: 'StyleCategory',
        header: 'Categoria',
        className: 'colum-width-medium',
        body: (rowData) => rowData.StyleCategory,
        align: 'center',
      },
      {
        // Rollos
        field: 'Rollos',
        header: 'Rollos',
        className: 'colum-width-medium',
        body: (rowData) => rowData.Rollos,
        Format: 'Currency',
        Sumary: 'sum',
      },
      {
        // Yds
        field: 'Yds',
        header: 'Yds',
        className: 'colum-width-medium',
        body: (rowData) => rowData.Yds,
        Format: 'Currency',
        Sumary: 'sum',
      },
      {
        // Kgs
        field: 'Kgs',
        header: 'Kgs',
        className: 'colum-width-medium',
        body: (rowData) => rowData.Kgs,
        Format: 'Currency',
        Sumary: 'sum',
      },
      {
        // Lbs
        field: 'Lbs',
        header: 'Lbs',
        className: 'colum-width-medium',
        body: (rowData) => rowData.Lbs,
        Format: 'Currency',
        Sumary: 'sum',
      },
      {
        // Valor
        field: 'Amount',
        header: 'Valor ($)',
        className: 'colum-width-large',
        body: (rowData) => rowData.Amount,
        Format: 'Currency',
        Sumary: 'sum',
        frozen: 'frozen',
        alignFrozen: "right",

      },
    ],
    key: 'IdInvoice',
    scrollHeight: '80vh',
  })


  const getInfo = async () => {
    setLoading(true);
    setTable({
      ...table,
      Data: [],
    
    })

    if (fechas[0] && fechas[1]) {
      const f = getDateProduction(fechas);
      const tempo = await FacturacionDiaria({ Fecha1: f[0], Fecha2: f[1] });
      setTable({
        ...table,
        Data: tempo,
      });
      if (tempo.length === 0) {
        toastShow(toast, 'info', 'No hay facturacion para el ranfo de fechas seleccionado');
      }
    } else {
      toastShow(toast, 'warn', 'Error', 'Seleccione un rango de fechas')
    }
    setLoading(false);
  }


  useEffect(() => {
    getInfo();
    setTitlePage('Facturación')
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])



  return (
    <div id={'facturacionDiariaScreen'}>
      <Toast position="bottom-right" ref={toast} />
      <Loader loading={loading} querySelector={'#facturacionDiariaScreen'} />
      <Card
        titulo={
        <div className='d-flex flex-row'>
            <h3>Facturación Diaria</h3>
          <div className='mx-2'>
              <Calendar monthNavigator yearNavigator yearRange='2010:2030' showButtonBar dateFormat="dd/mm/yy" value={fechas} onChange={(e) => setFechas(e.value)} selectionMode="range" showIcon />
              <Button loading={loading} className='mx-2' icon='pi pi-search' onClick={getInfo} />
            </div>
          </div>}
        contenido={
            <div className='pt-4' style={{ height: '83vh', }}>
              <AgGrid table={table} />
            </div>

        }

      />

    </div>
  )
}

export default FacturacionDiariaScreen